import { useEffect, useState } from "react";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { CementPackagingForm } from "./CementPackagingForm";
import { CementPackagingService } from "./core/_request";
import { HttpStatusCode } from "axios";
import {
  useCementPackagingListState,
  useCementPackagingStore,
} from "./store/CementPackagingStore";
import { Loader } from "../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

const CementPackagingList = () => {
  const {
    setCementPackagingList,
    cementPackagingList,
    actioned,
    totalItems,
    setActioned,
  } = useCementPackagingStore();
  const { pageState, setPageState, resetPageState } =
    useCementPackagingListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Nom",
      dataIndex: "name",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "capacity",
      title: "Capacité (T)",
      dataIndex: "capacity",
      isCanSort: true,
      show: true,
    },
  ];

  useEffect(() => {
    fetchAllCementPackaging(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await CementPackagingService.getCementPackaging(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await CementPackagingService.deleteCementPackaging(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllCementPackaging();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllCementPackaging = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await CementPackagingService.getCementPackagingList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setCementPackagingList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Conditionnement ciment"
        isEnableAdd
        onClickOnAdd={onClickOnAdd}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={cementPackagingList}
            params={pageState}
            onAction={onActionClick}
            isCanDelete={() => true}
            isCanEdit={() => true}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            onChangePage={handleSetParams}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <CementPackagingForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};

export default CementPackagingList;
